import http from '../http'
const { API_URL } = require('../../../config')

/**
 * 获取最新版本信息
 */
export const getLatestRelease = () => {
  return http.get('/api/system/releases/latest')
}

/**
 * 发起 OSS 文件归档移动任务
 * @param {Object} payload 归档参数，支持 workIds / ids / beforeTime / startTime + endTime / dryRun / confirm 等
 */
export const archiveOssFiles = (payload) => {
  return http.post('/api/system/archive-oss-files', payload)
}

/**
 * 查询 OSS 文件归档移动任务进度
 * @param {string} jobId 任务 ID
 */
export const getArchiveOssFilesJob = (jobId) => {
  return http.get(`/api/system/archive-oss-files/${encodeURIComponent(jobId)}`)
}

/**
 * 下载发布版本
 * @param {string|number} id - 版本ID
 * @param {string} fileName - 文件名
 */
export const downloadRelease = (id, fileName) => {
  const baseURL = API_URL || (http.defaults && http.defaults.baseURL) || ''
  const url = `${baseURL.replace(/\/$/, '')}/api/system/releases/${id}/download`
  // 创建临时链接并触发下载
  const link = document.createElement('a')
  link.href = url
  link.download = fileName || 'download'
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
